import React from 'react';
import Title from '../Title';
import Paragraph from '../Paragraph';
import './styles.scss';

const Index = (props) => {
  return (
    <div className="card">
      <img
        className="card__image"
        alt={props.title}
        src={props.image}
        srcSet={`${props.image2x} 2x, ${props.image3x} 3x`}
      />
      <div className="card__body">
        <Title>{props.title}</Title>
        <Paragraph>{props.children}</Paragraph>
      </div>
    </div>
  );
};

export default Index;
